import { post, get } from '@/axios/method';


// 获取banner图列表(李建)
export const getBannerList = (data) => get('/api/dm/market/study-resource/getBannerList', data);